// extracted by mini-css-extract-plugin
var _1 = "TEhlt9Jr";
var _2 = "V6ka0Fmo";
export { _1 as "newPostBtn", _2 as "postsSlot" }
